import { KEYS } from 'app/constants/SceneConstants';
import { FONT_BASE } from '../constants/AppFonts';
import SceneBaseTT from './SceneBaseTT';

export default class ConfirmAction extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.ConfirmAction, active: false });
  }

  init(config) {
    this._data = config.data;
  }

  create() {
    super.create();

    this.game.hud.events.on('btn_confirm', this.handleConfirmAction, this);
    this.game.hud.events.on('btn_cancel', this.handleCancelActon, this);
    this.game.hud.events.on('btn_confirm_back', this.handleConfirmAction, this);
    switch (this._data.type) {
      case 'unlock':
        this.renderConfirmUnlock(this._data.price);
        break;
      case 'nomoney':
        this.renderNoMoney(this._data.price);
        break;
      case 'home':
        this.renderReturnHome();
        break;
      case 'newgame':
        this.renderNewGame();
        break;
    }
  }

  renderReturnHome() {
    this.setBackgroundImage('overlay_purple');
    this.add.image(this.centerX, this.centerY, 'graphics', 'overlay_panel_blue');
    this.add.image(this.centerX, 202, 'locale_text', 'title_confirm');
    this.add.image(this.centerX, 360, 'locale_text', 'copy_confirmhome');
    this.game.hud.setState('CONFIRM_HOME');
  }

  renderNewGame() {
    this.setBackgroundImage('overlay_purple');
    this.add.image(this.centerX, this.centerY, 'graphics', 'overlay_panel_blue');
    this.add.image(this.centerX, 202, 'locale_text', 'title_confirm');
    this.add.image(this.centerX, 360, 'locale_text', 'copy_confirmnewgame');
    this.game.hud.setState('CONFIRM_HOME');
  }

  renderNoMoney(price) {
    this.setBackgroundImage('overlay_purple');
    this.add.image(this.centerX, this.centerY, 'graphics', 'overlay_panel_yellow');
    this.add.image(this.centerX, 434, 'graphics', 'overlay_panel_strip');
    this.add.image(this.centerX, 202, 'locale_text', 'title_oops');
    this.add.image(this.centerX, 326, 'locale_text', 'copy_notenoughcoins');
    const text = this.add
      .text(0, 434, price, {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 42,
        align: 'left',
        color: '#FFFFFF',
      })
      .setOrigin(0, 0.5);
    const icon = this.add.image(this.centerX, 434, 'graphics', 'icon_coin').setOrigin(0, 0.5);
    const width = icon.width + text.displayWidth + 15;
    icon.x = this.centerX - width * 0.5;
    text.x = icon.x + icon.width + 15;
    this.game.hud.setState('NO_MONEY');
  }

  renderConfirmUnlock(price) {
    this.setBackgroundImage('overlay_blue');
    this.add.image(this.centerX, this.centerY, 'graphics', 'overlay_panel_blue');
    this.add.image(this.centerX, 434, 'graphics', 'overlay_panel_strip');
    this.add.image(this.centerX, 202, 'locale_text', 'title_confirm');
    this.add.image(this.centerX, 326, 'locale_text', 'copy_confirmunlock');
    const text = this.add
      .text(0, 434, price, {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 42,
        align: 'left',
        color: '#FFFFFF',
      })
      .setOrigin(0, 0.5);
    const icon = this.add.image(this.centerX, 434, 'graphics', 'icon_coin').setOrigin(0, 0.5);
    const width = icon.width + text.displayWidth + 15;
    icon.x = this.centerX - width * 0.5;
    text.x = icon.x + icon.width + 15;
    this.game.hud.setState('CONFIRM_ACTION');
  }

  handleConfirmAction() {
    this.game.sceneController.removeOverlayScene();
    this.game.hud.resumePreviousState();
    if (this._data.onConfirm) this._data.onConfirm.apply(this._data.onConfirmScope);
  }

  handleCancelActon() {
    this.game.sceneController.removeOverlayScene();
    this.game.hud.resumePreviousState();
    if (this._data.onCancel) this._data.onCancel.apply(this._data.onCancelScope);
  }

  shutdown() {
    this.game.hud.events.off('btn_confirm', this.handleConfirmAction, this);
    this.game.hud.events.off('btn_cancel', this.handleCancelActon, this);
    this.game.hud.events.off('btn_confirm_back', this.handleConfirmAction, this);
    super.shutdown();
  }
}
